export const TAB_SUCCESS_REPORT_TYPE = "cargo-report,cargo-flight-awb-receipt";
export const DEFAULT_INTERNATIONAL_PRODUCT = "LION INTERNATIONAL";